import { createSlice } from "@reduxjs/toolkit";

export const mockSurveillanceAdoptDevices = [
  {
    code: 0,
    message: "Success",
    macAddress: "0c:b6:d2:fa:45:30",
  },
  {
    code: 0,
    message: "Success",
    macAddress: "0c:b6:d2:fa:45:31",
  },
  {
    code: 0,
    message: "Success",
    macAddress: "0c:b6:d2:fa:45:32",
  },
  {
    code: 4,
    message: "Failure",
    macAddress: "0c:b6:d2:fa:45:33",
  },
  {
    code: 0,
    message: "Success",
    macAddress: "0c:b6:d2:fa:45:34",
  },
  {
    code: 4,
    message: "Failure",
    macAddress: "0c:b6:d2:fa:45:35",
  },
  {
    code: 0,
    message: "Success",
    macAddress: "0c:b6:d2:fa:45:36",
  },
  {
    code: 4,
    message: "Failure",
    macAddress: "0c:b6:d2:fa:45:37",
  },
];

export const surveillanceAdoptDevicesSlice = createSlice({
  name: "surveillanceAdoptDevices",
  initialState: {
    resource: "surveillanceAdopt",
    data: [...mockSurveillanceAdoptDevices],
  },
});

export default surveillanceAdoptDevicesSlice.reducer;
